import React from 'react';
import { Typography } from '../../../_shared/components/Typography/Typography';
import { StatusLabel } from '../../../_shared/components/StatusLabel/StatusLabel';
import styles from './FactsHeader.module.scss';

interface Props {
  year: number;
  status: string;
  lastUpdate: string;
  factDeadline: string;
  appealDeadline: string;
  premiumDeadline: string;
}

export function FactsHeader({
  year,
  status,
  lastUpdate,
  factDeadline,
  appealDeadline
}: Props) {
  return (
    <div className={styles.header}>
      <Typography variant="h1">Итоги КПЭ за {year} год</Typography>
      <div className={styles.meta}>
        <div className={styles.metaItem}>
          <Typography variant="caption">Статус кампании</Typography>
          <StatusLabel variant="info">{status}</StatusLabel>
        </div>
        <div className={styles.metaItem}>
          <Typography variant="caption">Последнее обновление</Typography>
          <Typography variant="text">{lastUpdate}</Typography>
        </div>
        <div className={styles.metaItem}>
          <Typography variant="caption">Дедлайн на ввод</Typography>
          <Typography variant="text">{factDeadline}</Typography>
        </div>
        <div className={styles.metaItem}>
          <Typography variant="caption">
            Передача документов на выплату премий
          </Typography>
          <Typography variant="text">{appealDeadline}</Typography>
        </div>
      </div>
    </div>
  );
}
